import React, {useState, useEffect, useContext} from "react";
import useToggle from "hooks/useToggle";
import CommonDropdown from "components/dropdowns/common-dropdown";
import ModalDropdown from "components/dropdowns/modal-dropdown";
import carFinder from "../../assets/svgs/car-finder.svg";
import {ProductFinderContext} from "@root/context/product-finder";

export const defaultBackGroundImages = [
    {
        key: "car",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/faddeb4d67bbb2ff7cf2cd75a0aabed22bcd07de-2332x432.png",
    },
    {
        key: "truck",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/605502cd1ceb599bee9110d708573cbec7de9849-2332x432.png",
    },
    {
        key: "suv",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/7d3e2d5a09e1667e8f28f08609dfb50007d5f1cf-2332x432.png",
    },
    {
        key: "van",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/87b7fb14dfc4f03efad7f92f0fc2d06e1d4fbadf-2332x432.png",
    },
    {
        key: "boat",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/65064c5dd7f9454d86d7f56e0571e57de7edf836-2332x430.png",
    },
    {
        key: "jet-ski",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/fc64b4432aa3506f38fc61382d8ff19a58c9acd9-1174x224.png",
    },
    {
        key: "jetski",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/fc64b4432aa3506f38fc61382d8ff19a58c9acd9-1174x224.png",
    },
    {
        key: "bimini",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/f69a9564313181835cd45472c43dc12fb64d2569-2332x432.png",
    },
    {
        key: "pontoon",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/e3e17cff06bbea415ab6391130edd24e2142ad0f-2332x432.png",
    },
    {
        key: "motorcycle",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/8f7428219ba516cee5c1e37fce51bb83c6d5f909-2332x432.png",
    },
    {
        key: "atv",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/1c150cd13c15caeec3647e91f1fd071041d3e6a7-1166x216.png",
    },
    {
        key: "utv",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/ab3bea11d545045271abcd92fc31ff88e8a1f268-1166x216.png",
    },
    {
        key: "scooter",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/eeb44715112fd3b87e8add477aba20a1dad5612e-2332x432.png",
    },
    {
        key: "snowmobile",
        image: "https://cdn.sanity.io/images/4swbd7aj/pre-prod/a8f1b004b96ce435247eeec55b368e735d57d399-1166x216.png",
    },
];

const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const initialMakeExists = (initialMake) => initialMake !== undefined && initialMake !== "";

const dropdownAttributes = (initialMake, dropdownsArr, iterationIndex, selected, name, hideOptionDropdown, isShoppingFeed) => {
    const dropdownNumber = initialMakeExists(initialMake) ? iterationIndex : iterationIndex + 1;
    const hasSearch = iterationIndex === 0;
    const disabled = hasSearch ? false : dropdownsArr[iterationIndex - 1].selected === null;
    const selectedValue = selected !== null ? selected : `${!isShoppingFeed ? `${iterationIndex + 1} | ` : ''}Select ${capitalizeFirstLetter(name)}`;
    const isNull = ((initialMakeExists(initialMake) && hasSearch) || (hideOptionDropdown && name === "option"));
    return {
        hasSearch, disabled, selectedValue, isNull, dropdownNumber,
    };
};

export const DesktopDropdowns = ({ dropdownsArr, initialMake, onSelect, className, hideOptionDropdown, onGoToCollection, isShoppingFeed = false }) => (
    <div className={`flex justify-center lg:flex-row lg:gap-5 gap-4 ${className}`}>
        {isShoppingFeed && (
            <div className="finder-select-vehicle">Select Vehicle</div>
        )}
        {dropdownsArr.map((dropdown, index) => {
            const { selected, list, name } = dropdown;
            const { disabled, selectedValue, isNull, dropdownNumber } = dropdownAttributes(initialMake, dropdownsArr, index, selected, name, hideOptionDropdown, isShoppingFeed);
            if (isNull) return null;

            return (
                <CommonDropdown
                    selected={selectedValue}
                    hasValue={selected !== null}
                    options={list}
                    optionProperty={name}
                    onSelect={onSelect}
                    hasSearch
                    disabled={disabled}
                    className={`w-full relative ${isShoppingFeed ? "min-w-[140px]" : ""}`}
                    key={name}
                    dropdownNumber={dropdownNumber}
                />
            );
        })}

        <div className="desktop-finder__button-wrapper">
            <button
                type="button"
                className="desktop-finder__button"
                onClick={() => onGoToCollection(dropdownsArr[dropdownsArr.length - 1]?.selected)}
            >
                {isShoppingFeed ? "FIND MY COVER" : "Go"}
            </button>
        </div>
    </div>
);

export const MobileDropdowns = ({
    dropdownsArr,
    onSelect,
    initialMake,
    className,
    hideOptionDropdown,
    onGoToCollection,
    onGoBack,
    firstDropdownIndex,
    isShoppingFeed = false,
}) => {
    const { isOpen, toggle } = useToggle();
    const [journeyIndex, setJourneyIndex] = useState(initialMake ? 1 : 0);
    const [isMobile, setIsMobile] = useState(true);


    const { errorField, setErrorField, errorFieldRefresher } = useContext(ProductFinderContext);

    function getNextEmptyDropdownIndex() {
        const selectedDropdowns = dropdownsArr.map((dropdown) => dropdown.selected);
        return selectedDropdowns.findIndex((selected) => selected === null);
    }

    useEffect(() => {
        if (errorField) {
            toggle();
            setJourneyIndex(dropdownsArr.findIndex((dropdown) => dropdown.name === errorField));
        }
    }, [errorField, errorFieldRefresher]);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleGoBack = (dropdownName) => {
        onGoBack(dropdownName);

        if (journeyIndex === firstDropdownIndex) {
            toggle();
            return;
        }
        setJourneyIndex((prevState) => prevState - 1);
    };

    const handleSelect = (dropdownName, selectedValue) => {
        onSelect(dropdownName, selectedValue);
        setJourneyIndex((prevState) => prevState + 1);
    };

    const handleOpenModal = (dropdownIndex) => {
        const selectedDropdown = dropdownsArr[dropdownIndex];
        if (selectedDropdown?.list?.length === 0) return;
        setJourneyIndex(dropdownIndex);
        toggle();
    };

    const getSelectedVehicleText = () => {
        const make = dropdownsArr.find((dropdown) => dropdown.name === "make")?.selected;
        const year = dropdownsArr.find((dropdown) => dropdown.name === "year")?.selected;
        const model = dropdownsArr.find((dropdown) => dropdown.name === "model")?.selected;

        if (make && year && model) {
            return `${year} ${make} ${model}`;
        }
        return null;
    };

    const selectedVehicle = getSelectedVehicleText();

    return (
        <div className={`finder-mobile flex flex-col ${className} gap-4 ${isShoppingFeed ? "finder-mobile--shopping-feed" : ""}`}>
            <button
                type="button"
                onClick={() => handleOpenModal(getNextEmptyDropdownIndex())}
                className="finder-mobile__select-vehicle shopping-feed-finder__ymm"
            >
                <img src={carFinder} alt="Car Finder"/>
                <span className="shopping-feed-finder__ymm-button">Select Your Vehicle</span>
            </button>

            <div className={"finder-mobile__dropdowns flex flex-col gap-4"}>
                {dropdownsArr.map((dropdown, index) => {
                    const {list, name, selected} = dropdown;
                    const {
                        selectedValue,
                        isNull,
                        disabled
                    } = dropdownAttributes(initialMake, dropdownsArr, index, selected, name, hideOptionDropdown);
                    const showModal = !!isOpen && index === journeyIndex;

                    if (isNull) return null;
                    return (
                        <ModalDropdown
                            options={list}
                            optionProperty={name}
                            selected={selectedValue}
                            onSelect={handleSelect}
                            onOpen={() => handleOpenModal(index)}
                            onGoBack={handleGoBack}
                            showModal={showModal}
                            key={name}
                            disabled={disabled}
                            hasSearch
                            isFullPage={isShoppingFeed}
                            dropdownsArr={dropdownsArr}
                            dropdownNumber={index + 1}
                        />
                    );
                })}
            </div>

            {/* Go Button that should only show on mobile landing pages */}
            <button
                type="button"
                className="finder-mobile__go text-center bg-orange-703 text-blue-700 md:py-2.5 py-1.5 px-2 rounded-lg"
                onClick={() => onGoToCollection(dropdownsArr[dropdownsArr.length - 1]?.selected)}
            >
                Go
            </button>
        </div>
    );
};
